import {MutationTree} from 'vuex';
import {AddressInitState, Amphures, Districts, Provinces} from '@/store/address/address.types';

export const AddressMutations: MutationTree<AddressInitState> = {
  ['mutationGetProvinces'](state: AddressInitState, payload: Provinces[]) {
    state.provinces = payload;
  },
  ['mutationGetAmphures'](state: AddressInitState, payload: Amphures[]) {
    state.amphures = payload;
  },
  ['mutationGetDistricts'](state: AddressInitState, payload: Districts[]) {
    state.districts = payload;
  }
};
